(function ($) {

    /*------------------------------------*\
        DEVHUB BRAND TOGGLE
        Switches brand CSS loaded into the component preview iframe.
        Buttons: .js-brand-btn[data-brand]
        Frame:   .js-component-preview-frame
        Frame data attrs carry the CSS/HTML/JS needed to rebuild the srcdoc
        per brand:  data-global-css, data-nerdworks-css,
                    data-component-html, data-component-css, data-component-js
    \*------------------------------------*/

    $.fn.devhubBrandToggle = function () {

        var init = function () {

            $(document).on('click', '.js-brand-btn', function () {

                var $btn   = $(this);
                var brand  = $btn.data('brand');
                var $frame = $('.js-component-preview-frame');

                $btn.closest('.devhub-brand-toggle').find('.js-brand-btn').removeClass('is-active');
                $btn.addClass('is-active');

                var globalCss       = $frame.data('global-css') || '';
                var nerdworksCss    = $frame.data('nerdworks-css') || '';
                var componentHtml   = $frame.data('component-html') || '';
                var componentCss    = $frame.data('component-css') || '';
                var componentJs     = $frame.data('component-js') || '';

                var srcdoc = '<link rel="stylesheet" href="' + globalCss + '">';

                if ('nerdworks' === brand && nerdworksCss) {
                    srcdoc += '<link rel="stylesheet" href="' + nerdworksCss + '">';
                }

                if (componentCss) {
                    srcdoc += '<style>' + componentCss + '</style>';
                }

                srcdoc += componentHtml;

                if (componentJs) {
                    srcdoc += '<script src="https://code.jquery.com/jquery-3.6.0.min.js"><\/script>';
                    srcdoc += '<script>' + componentJs + '<\/script>';
                }

                $frame.attr('srcdoc', srcdoc);

            });

        };

        init();

        return this;

    };

}(jQuery));
